import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { ShortUrl } from '@air/api';

const getPublicCountriesListKey = ({
  shortId,
  search,
  boardId,
}: {
  shortId: string | undefined;
  search: string;
  boardId: string | undefined;
}) => ['PUBLIC_COUNTRIES', { shortId, search, boardId }];

export const usePublicCountriesList = ({
  search,
  shortId,
  boardId,
}: {
  search: string;
  shortId: string;
  boardId: string | undefined;
}) => {
  const key = getPublicCountriesListKey({ shortId, search, boardId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(shortId, 'Short ID is required');

      const data = await ShortUrl.getAssetVersionFilterLookups({
        limit: 20,
        shortId,
        descendantBoardId: boardId,
        field: 'location.country',
        search,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!shortId,
  });
};
